import { defineManifest } from '@ndrc/app-sdk/manifest';
import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'service_client',
  name: fr.title,
  description: fr.description,
  icon: 'headphones',
  color: '#1D4ED8',
  glyph: [{ d: 'M6 4h12v16H6z' }, { d: 'M9 8h6M9 11h6M9 14h3' }, { d: 'm13 17 1.5 1.5L18 15' }],
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'relation-client',
  permissions: {
    uses: [
      'app.records.read',
      'app.records.write',
      'tickets.read',
      'tickets.write',
      'contacts.read',
      'employees.read',
      'employees.write',
      'interactions.read',
      'interactions.write',
    ],
    defines: [],
  },
  entities: {
    uses: [
      { entity: 'contacts' },
      { entity: 'employees' },
      {
        entity: 'tickets',
        extends: {
          status: ['open', 'in_progress', 'waiting', 'closed'],
          channel: ['email', 'call', 'chat', 'web'],
        },
      },
      { entity: 'interactions', extends: { channel: ['request'] } },
    ],
    owns: [{ table: 'preparations', scope: 'workspace', description: fr.description }],
  },
  events: { emits: emitsOf(events), subscribes: [] },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: fr.title }], layout: 'full' },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  contributes: {
    entityActions: [
      {
        entity: 'contacts',
        label: fr.actionLabel,
        icon: 'headphones',
        intent: 'service_client.ticket.new',
        route: '/?contactId=:id',
      },
    ],
  },
  missions: { actions: ['service_client.seed'], conditions: ['service_client.closed'], blocks: [] },
  migrations: { schema: 'app_service_client', dir: 'migrations' },
});
